import { useNavigate } from "react-router-dom";

export const Declined = () => {
  const navigate = useNavigate();
  navigate("/decline");
  return null;
};